import { API } from 'aws-amplify';

import {
	FETCH_CU_SMELTER_PRODUCTION,
	FETCH_CU_SMELTER_PRODUCTION_ERR,
	RESET_CU_SMELTER_PRODUCTION,
	FETCH_CU_MTD_PRODUCTION,
	FETCH_CU_MTD_PRODUCTION_ERR,
	FETCH_CU_PRODUCTION_BY_SMELTER,
	FETCH_CU_PRODUCTION_BY_SMELTER_ERR,
	RESET_CU_PRODUCTION_BY_SMELTER,
	SELECT_CU_PROD_SMELTER,
	UNSELECT_CU_PROD_SMELTER,
	RESET_CU_PROD_SMELTERS
} from '../';
import config from '../../config';
import { replacer } from '../../utils';
import { clearApiRetry, showApiMessages } from '../../apiMessages';

export const fetchCuSmelterProduction =
	({
		grouping,
		id = '',
		collapse,
		ute = '',
		capAdd = '',
		startDate = '',
		endDate = ''
	}) =>
	async (dispatch, getState) => {
		const retryKey = JSON.stringify({
			grouping,
			id,
			collapse,
			ute,
			capAdd,
			startDate,
			endDate
		});
		clearApiRetry('Copper production', retryKey);
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.cuSmelterProduction, {
				grouping,
				id,
				collapse,
				ute,
				capAdd,
				startDate,
				endDate
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) => {
				showApiMessages({
					retryKey,
					response,
					sites: getState ? getState().sites : [],
					title: 'Copper production'
				});
				dispatch({
					type: FETCH_CU_SMELTER_PRODUCTION,
					payload: {
						[collapse]:
							response.combinedIdx || response.singleIdx?.[0]?.data || []
					}
				});
			},
			(err) => {
				showApiMessages({
					retryKey,
					response: { error: err },
					title: 'Copper production',
					onRetry: () => dispatch(fetchCuSmelterProduction({
						grouping,
						id,
						collapse,
						ute,
						capAdd,
						startDate,
						endDate
					}))
				});
				return dispatch({
					type: FETCH_CU_SMELTER_PRODUCTION_ERR,
					payload: err
				});
			}
		);
	};
export const resetCuSmelterProduction = () => (dispatch) => {
	clearApiRetry('Copper production');
	return dispatch({ type: RESET_CU_SMELTER_PRODUCTION });
};

export const fetchCuMtdProduction =
	({ grouping, id = '', ute = '' }) =>
	async (dispatch, getState) => {
		const retryKey = JSON.stringify({
			grouping,
			id,
			ute
		});
		clearApiRetry('Copper month-to-date production', retryKey);
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.cuMtdProduction, {
				grouping,
				id,
				ute
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) => {
				showApiMessages({
					retryKey,
					response,
					sites: getState ? getState().sites : [],
					title: 'Copper month-to-date production'
				});
				dispatch({
					type: FETCH_CU_MTD_PRODUCTION,
					payload: response
				});
			},
			(err) => {
				showApiMessages({
					retryKey,
					response: { error: err },
					title: 'Copper month-to-date production',
					onRetry: () => dispatch(fetchCuMtdProduction({
						grouping,
						id,
						ute
					}))
				});
				return dispatch({
					type: FETCH_CU_MTD_PRODUCTION_ERR,
					payload: err
				});
			}
		);
	};

export const resetCuMtdProduction = () => {
	clearApiRetry('Copper month-to-date production');
	return {
		type: FETCH_CU_MTD_PRODUCTION,
		payload: []
	};
};

export const fetchCuProductionBySmelter =
	({ ids, collapse, ute = '', startDate = '', endDate = '' }) =>
	async (dispatch, getState) => {
		const retryKey = JSON.stringify({
			ids,
			collapse,
			ute,
			startDate,
			endDate
		});
		clearApiRetry('Copper site production', retryKey);
		const request = API.get(
			'gains-api',
			replacer(config.apiEndpoints.cuProductionBySmelters, {
				ids,
				collapse,
				ute,
				startDate,
				endDate
			}),
			{
				headers: {}
			}
		);

		return request.then(
			(response) => {
				showApiMessages({
					retryKey,
					response,
					sites: getState ? getState().sites : [],
					title: 'Copper site production'
				});
				return dispatch({
					type: FETCH_CU_PRODUCTION_BY_SMELTER,
					payload: response
				});
			},
			(err) => {
				showApiMessages({
					retryKey,
					response: { error: err },
					title: 'Copper site production',
					onRetry: () => dispatch(fetchCuProductionBySmelter({
						ids,
						collapse,
						ute,
						startDate,
						endDate
					}))
				});
				return dispatch({
					type: FETCH_CU_PRODUCTION_BY_SMELTER_ERR,
					payload: err
				});
			}
		);
	};

export const resetCuProductionBySmelter = () => {
	clearApiRetry('Copper site production');
	return {
		type: RESET_CU_PRODUCTION_BY_SMELTER,
		payload: {}
	};
};

export const selectCuProdSmelter = (key) => ({
	type: SELECT_CU_PROD_SMELTER,
	payload: key
});

export const unselectCuProdSmelter = (key) => ({
	type: UNSELECT_CU_PROD_SMELTER,
	payload: key
});

export const resetCuProdSmelters = () => ({
	type: RESET_CU_PROD_SMELTERS
});
